import { useState } from "react";
import { conditionalBoolQuery, getBatch, getSortedCollection, matchQuery } from "sprint-common-web";

import { LanguageItem } from "../LanguagesListing";
import { LanguagesListingFilters } from "./useLanguagesListingFilters";

export const useLanguagesListingData = () => {
    const [items, setItems] = useState<LanguageItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const saveData = (
        languageItems: LanguageItem[],
        { name, page, pageSize, sortBy, sortOrder, code, dubbingsOnly, subtitlesOnly }: LanguagesListingFilters
    ): void => {
        const filteredLanguages = languageItems
            .filter((language) => matchQuery(language.name, name))
            .filter((language) => matchQuery(language.code, code))
            .filter((language) => conditionalBoolQuery(language.isDubbing, dubbingsOnly))
            .filter((language) => conditionalBoolQuery(language.isSubtitle, subtitlesOnly));

        setTotalItems(filteredLanguages.length);

        const sortedCollection = getSortedCollection(filteredLanguages, sortBy, sortOrder);

        const slicedLanguages = getBatch(sortedCollection, pageSize, page);

        setItems(slicedLanguages);
    };

    return {
        items,
        totalItems,
        saveData
    };
};
